export default "__VITE_ASSET__pcVXfv5I__"